/**
 * 当前允许选择的登录方式
 */
export const LOGIN_PAGES = {
    DEFAULT: '/login',
    BIND_LOGIN: '/login/bind_login/auth'
}
  